import { createFileRoute } from "@tanstack/react-router";

import { Dataset } from "./-dataset";
import { parseDatasetSearch } from "../../../workspaces/library/pages/dataset-search";

export const Route = createFileRoute(
  "/_console/p/$org/$project/library/datasets/$name/segments/$segmentId",
)({
  validateSearch: parseDatasetSearch,
  component: SegmentRoute,
});

/** One segment of one dataset, open in the inspector — the recording an engineer means
 *  when they send the link. */
function SegmentRoute() {
  const { name, segmentId } = Route.useParams();
  return (
    <Dataset name={name} state={{ ...Route.useSearch(), segment: segmentId }} />
  );
}
